<template>
    <div>
        <b-form-checkbox
            id="checkbox-1"
            v-model="show"
            :name="name"
            :value="true"
            :unchecked-value="false" >
            {{ title }}
        </b-form-checkbox>
        <b-collapse id="furikae" v-model="show">
            <!-- <slot v-if="show"></slot> -->
            <slot></slot>
        </b-collapse>
    </div>
</template>
<script>
    export default {
        props: {
            title: String,
            name: String,
            checked: Boolean
        },
        data: function() {
            return {
                show: this.checked,
            }
        },
        methods: {
        }
    }
</script>
